import PropTypes from "prop-types";
import parse from "html-react-parser";
import * as S from "./HTMLParser.styles";

export const HTMLParser = ({ html }) => <S.HTMLView id="HTMLParser_html">{parse(html)}</S.HTMLView>;

HTMLParser.propTypes = {
  html: PropTypes.any,
};
